export interface IProdEnvSettings {
  name: string;
  mscrmappServiceApiUrl: string;
  production: boolean;
  isProduction: string;
  credentialsUrl: string;
  commerceServiceApiUrl: string;
  crmTypeIdentifierUrl: string;
}

declare global {
  interface Window {
    COMMERCE_ENVIRONMENT_SETTINGS: IProdEnvSettings;
  }
}

export const environment: IProdEnvSettings = {
  name: window.COMMERCE_ENVIRONMENT_SETTINGS.name,
  production: window.COMMERCE_ENVIRONMENT_SETTINGS.production,
  mscrmappServiceApiUrl: window.COMMERCE_ENVIRONMENT_SETTINGS.mscrmappServiceApiUrl,
  isProduction: window.COMMERCE_ENVIRONMENT_SETTINGS.isProduction,
  credentialsUrl: window.COMMERCE_ENVIRONMENT_SETTINGS.credentialsUrl,
  commerceServiceApiUrl: window.COMMERCE_ENVIRONMENT_SETTINGS.commerceServiceApiUrl,
  crmTypeIdentifierUrl: window.COMMERCE_ENVIRONMENT_SETTINGS.crmTypeIdentifierUrl,
};
